import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core';

@Component({
  selector: 'app-audit-landing-strip',
  templateUrl: './audit-landing-strip.component.html',
  styles: []
})
export class AuditLandingStripComponent extends ExcTranslation implements OnInit {
  // tslint:disable-next-line:no-input-rename
  @Input('header') header;
  // tslint:disable-next-line:no-input-rename
  @Input('data') data = [];
  // tslint:disable-next-line:no-input-rename
  @Input('month') month;
  // tslint:disable-next-line:no-input-rename
  @Input('year') year;
  constructor() {
    super();
  }
  getTimeFrame() {
    if (this.month && this.year) {
      let t = '0' + this.month;
      if (t.length > 2) {
        t = t.substring(t.length - 2, t.length);
      }
      t += '/' + this.year;
      return ': ' + t;
    }
    return '';
  }
  getContainerClass() {
    return 'grid cols-' + (this.data.length + 1) ;
  }
  ngOnInit() {
  }
  getClass (staus) {
    let str = 'ch-secondary';
    switch (staus) {
      case 1: str = 'th-secondary'; break;
      case 2: str = 'th-secondary'; break;
      case 3: str = 'th-secondary'; break;
      case 4: str = 'th-secondary'; break;
      case 5: str = 'th-secondary'; break;
      case 6: str = 'th-success'; break;
      case 7: str = 'th-warning'; break;
      case 8: str = 'th-danger'; break;
      case 9: str = 'th-danger'; break;
    }
    return str;
  }

}
